import { render, staticRenderFns } from "./leaveDialog.vue?vue&type=template&id=4044b54a&scoped=true&"
import script from "./leaveDialog.vue?vue&type=script&lang=js&"
export * from "./leaveDialog.vue?vue&type=script&lang=js&"
import style0 from "./leaveDialog.vue?vue&type=style&index=0&id=4044b54a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4044b54a",
  null
  
)

export default component.exports